exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-b0d42cd4]{width:100%;border-collapse:collapse}.reportTbl td[data-v-b0d42cd4]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-b0d42cd4]{text-align:left;line-height:15px}.txtRight[data-v-b0d42cd4]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-b0d42cd4]{text-align:center}.reportTbl tr.borderNo td[data-v-b0d42cd4]{border:none!important}.reportTbl tr.tb-td td[data-v-b0d42cd4]{font-weight:700;text-align:center}td.textCenter[data-v-b0d42cd4]{text-align:center!important}td.textBold[data-v-b0d42cd4]{font-weight:700}td.textRight[data-v-b0d42cd4]{text-align:right!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0d42cd4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/projectCashForStatementReport.vue
// module id = 1616
// module chunks = 3